import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=3f7a49bf&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=3f7a49bf&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7a49bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7a49bf')) {
      api.createRecord('3f7a49bf', component.options)
    } else {
      api.reload('3f7a49bf', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=3f7a49bf&scoped=true&", function () {
      api.rerender('3f7a49bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dXnwG13M0xhJ/JS/comp/Paginate.vue"
export default component.exports